import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { singleton } from "tsyringe";

import type TikTokPostEntity from "../entities/TikTokPostEntity";

export interface TikTokPostsState
    extends EntityState<TikTokPostEntity, number>,
        ActiveState {
    paginationMeta: {
        perPage: number;
        totalCount: number;
        currentOffset: number;
    };
}

export function createInitialState(): TikTokPostsState {
    return {
        paginationMeta: {
            perPage: 0,
            totalCount: 0,
            currentOffset: 0,
        },
        active: null,
    };
}

@singleton()
@StoreConfig({ name: "tiktok-posts", idKey: "postId" })
export class TikTokPostsStore extends EntityStore<TikTokPostsState> {
    constructor() {
        super(createInitialState());
    }
}
